<template>
  <div class='tenant-form__footer' :class="{ 'tenant-form__footer--top': top }">
    {{ downloadText }}:
    <input
      class='theme-btn theme-btn--small theme-btn--secondary'
      :class="{'theme-btn--secondary-disabled': disabled}"
      type='submit'
      name='type'
      value='PDF'
      title='Save as pdf'
      :disabled='disabled'
    >
    <input
      class='theme-btn theme-btn--small theme-btn--secondary'
      :class="{'theme-btn--secondary-disabled': disabled}"
      type='submit'
      name='type'
      value='ZIP'
      title='Save as zip'
      :disabled='disabled'
    >
    <input
      class='theme-btn theme-btn--small theme-btn--secondary'
      :class="{'theme-btn--secondary-disabled': disabled}"
      type='submit'
      name='type'
      value='PRINT'
      title='Print'
      @click.prevent='$emit("print")'
      :disabled='disabled'
    >
    <div>
      <label :for='selectAllId' class='tenant-form__checkbox'>
        <input
          type='checkbox'
          :name='selectAllId'
          :id='selectAllId'
          ref='selectAllInput'
          :checked='checked'
          @change='$emit("toggle-select-all", $event.target.checked)'
        />
        <div class='tenant-form__checkbox-indicator'></div>
        <span class='tenant-form__checkbox-label'>{{ selectAllCheckbox }}</span>
      </label>
    </div>
  </div>
</template>
<script>
  // Presentational only: no selection or download logic lives here. Both the top and bottom
  // bars in VTenantForm.vue render this same component against the SAME shared computed state
  // (isSomeCheckboxChecked/isAllCheckboxChecked/isSelectAllIndeterminate) and the SAME methods
  // (setStateToAllCheckboxes/print), so there is exactly one implementation of "what select all
  // means" and "how print/pdf/zip submit" - this component just renders it twice.
  export default {
    props: {
      downloadText: {
        default: '',
        type: String,
      },
      selectAllCheckbox: {
        default: '',
        type: String,
      },
      selectAllId: {
        required: true,
        type: String,
      },
      disabled: {
        default: false,
        type: Boolean,
      },
      checked: {
        default: false,
        type: Boolean,
      },
      indeterminate: {
        default: false,
        type: Boolean,
      },
      top: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      indeterminate: {
        immediate: true,
        handler(value) {
          this.$nextTick(() => {
            if (this.$refs.selectAllInput) {
              this.$refs.selectAllInput.indeterminate = value;
            }
          });
        },
      },
    },
  };
</script>
